import { render, staticRenderFns } from "./echelonDetail.vue?vue&type=template&id=56f4cb4c&scoped=true"
import script from "./echelonDetail.vue?vue&type=script&lang=js"
export * from "./echelonDetail.vue?vue&type=script&lang=js"
import style0 from "./echelonDetail.vue?vue&type=style&index=0&id=56f4cb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4cb4c",
  null
  
)

export default component.exports